import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import { Icon, Badge, Dropdown } from 'antd';

import { showSingleStep } from 'utils/tour';
import { hasUnreadNotification } from 'selectors';

import NotificationList from '../Notification/NotificationList';

class NotificationBadge extends React.Component {
  componentDidMount() {
    setTimeout(this.showGuide, 1000);
  }

  showGuide = () => {
    const { hasUnread, appTourParams } = this.props;
    if (hasUnread && appTourParams.guideMainMenu && !appTourParams.guideNotification) {
      showSingleStep({
        element: '#notificationBadge',
        popover: {
          title: 'Bạn có thông báo mới',
          description: 'Click vào biểu tượng để xem thông báo và Bấm vào từng dòng thông báo để xem chi tiết.',
          position: 'left',
          offset: 20,
        },
      }, () => {
        this.props.dispatch({ type: 'tour/updateParams', payload: { guideNotification: true } });
      });
    }
  }

  handleNotificationShow = (visible) => {
    if (visible) {
      this.props.dispatch({ type: 'notification/getNotifications' });
    }
  };

  render() {
    const { hasUnread, className } = this.props;
    const notificationPanel = (<NotificationList />);

    return (
      <Dropdown overlay={notificationPanel} placement="bottomRight" trigger={['click']} onVisibleChange={this.handleNotificationShow}>
        <div className={className} id="notificationBadge">
          <Badge dot={hasUnread}>
            <Icon type="notification" />
          </Badge>
        </div>
      </Dropdown>
    );
  }
}


export default connect(state => ({
  hasUnread: hasUnreadNotification(state),
  appTourParams: state.tour,
}))(NotificationBadge);



// WEBPACK FOOTER //
// ./src/components/Layout/NotificationBadge.js